<template>
  <div class="menu">
    <transition
      appear
      @before-appear="beforeAppear"
      @appear="enter"
      @enter="enter"
      @leave="leave">
      <div v-if="menuIsOpen" class="menu__head">
        <h3 class="menu__head-column">
          Alessandra Zanghi Studio
        </h3>
        <div
          v-hover-scale-mouse
          data-apollo-hover
          class="menu__head-column">
          <h3
            @click="pushAtPage({ name: 'Contact', path: '/contact' })">
            Contact
          </h3>
          <div class="menu__head__line" ref="line"/>
        </div>
      </div>
    </transition>
    <div class="menu__body">
      <div
        v-for="page in pages"
        :key="page.path"
        class="menu__item">
        <staggering-transition :delay="subtitleAnimationDelay">
          <h3
            v-if="menuIsOpen"
            class="menu__subtitle">
            {{ 'chapter ' + page.chapter }}
          </h3>
        </staggering-transition>
        <staggering-transition :delay="titleAnimationDelay">
          <h1
            v-hover-scale-mouse
            data-apollo-hover
            class="menu__title"
            @click="pushAtPage(page)"
            @mouseenter="mEnter"
            @mouseleave="mLeave">
            {{ page.name }}
          </h1>
        </staggering-transition>
      </div>
    </div>
    <transition
      appear
      @before-appear="beforeAppear"
      @appear="enter"
      @enter="enter"
      @leave="leave">
      <div v-if="menuIsOpen" class="menu__foot">
      </div>
    </transition>
  </div>
</template>

<script>
import anime from 'animejs';
import { mapMutations, mapState } from 'vuex';
import hades from '@/scripts/hades';

import menuLetterSpacingAnimation from '@/mixins/menuLetterSpacingAnimation';

import StaggeringTransition from '@/components/StaggeringTransition.vue';

export default {
  name: 'AppMenu',
  components: { StaggeringTransition },
  mixins: [menuLetterSpacingAnimation],
  data() {
    return {
      subtitleAnimationDelay: 500,
      titleAnimationDelay: 0,
    };
  },
  computed: {
    ...mapState([
      'menuIsOpen',
      'pages',
    ]),
  },
  methods: {
    ...mapMutations([
      'toggleMenu',
      'goAtPage',
    ]),
    pushAtPage({ name, path }) {
      if (this.$route.name !== name) {
        this.$router.push(path);
        this.goAtPage(name);
      }
      this.toggleMenu();
    },
    beforeAppear(el) {
      anime.set(el, {
        opacity: 0,
      });
    },
    enter(el, done) {
      anime({
        targets: el,
        opacity: 1,
        duration: 800,
        easing: 'easeInCubic',
        complete() {
          done();
        },
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        opacity: 0,
        duration: 800,
        easing: 'easeOutCubic',
        complete() {
          done();
        },
      });
    },
  },
  mounted() {
    hades.ref.scrollTo({ y: 0 }, 0);

    setTimeout(() => {
      this.isOpening = false;
    }, 1000);
  },
};
</script>

<style scoped lang="scss">
$vertical-padding-mobile: 10.2vw;
$horizontal-padding-mobile: 6.7vw;

$vertical-padding-tablet: 9.2vw;
$horizontal-padding-tablet: 9.4vw;

$vertical-padding: 5.2vw;
$horizontal-padding: 4.4vw;

$font-size-menu-item-mobile: 45px;
$lheight-menu-item-mobile: 60px;
$font-size-menu-item-default: 100px;
$lheight-menu-item-default: 130px;

.menu {
  padding: $vertical-padding-mobile $horizontal-padding-mobile;
  width: 100vw;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);

  background-color: transparent;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  z-index: 5;

  @include mq(ipadP) {
    padding: $vertical-padding-tablet $horizontal-padding-tablet;
  }

  @include mq(ds) {
    padding: $vertical-padding $horizontal-padding;
  }

  &__head,
  &__foot {
    flex-basis: 2rem;

    display: flex;
    align-items: center;
  }

  &__head {
    position: relative;
    width: 100%;
    transform: translateY(-50%);

    display: flex;
    justify-content: space-between;

    @include mq($until: mobileL) {
      justify-content: center;

      font-size: 14px;
      line-height: 16px;
    }

    &-column {
      position: relative;
      overflow: hidden;

      font-family: $font-family-base;
      letter-spacing: 0;

      &:nth-child(1) {
        margin-left: 11.5vw;
      }

      &:nth-child(2) {
      line-height: 1;
      padding-bottom: 0.5em;

        cursor: pointer;
        margin-right: 6.5vw;
      }

      @include mq($until: mobileL) {
        &:nth-child(1) {
          display: none;
          margin-right: 0;
        }
        &:nth-child(2) {
          margin-right: 0;
        }
      }
    }

    &:hover .menu__head__line {
      &::before {
        transform: translate3d(102%, 0, 0);
        opacity: 1;
      }

      &::after {
        transition: transform 0.4s cubic-bezier(.165, .84, .44, 1);
        transition-delay: 0.3s;
        transform: translate3d(0%, 0, 0);
        opacity: 1;
      }
    }
  }

  &__body {
    flex-basis: 50vh;
    max-height: 400px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;

    @include mq(ipadP) {
      flex-basis: 63vh;
      max-height: 500px;
    }

    @include mq(ds) {
      padding-top: 2vh;
      max-height: none;
    }
  }

  &__foot {
    width: 100%;
    max-width: 549px;

    display: flex;
    justify-content: center;
    align-items: center;

    transform: translateY(50%);

    @include mq($until: mobileL) {
      max-width: 150px;

      font-size: 14px;
      line-height: 16px;
    }

    &-column {
      position: relative;
      overflow: hidden;

      cursor: pointer;
      font-family: $font-family-base;
      line-height: 2;
      letter-spacing: 0;

      &:hover .menu__foot__line {
        &::before {
          transform: translate3d(102%, 0, 0);
          opacity: 1;
        }

        &::after {
          transition: transform 0.4s cubic-bezier(.165, .84, .44, 1);
          transition-delay: 0.3s;
          transform: translate3d(0%, 0, 0);
          opacity: 1;
        }
      }
    }
  }

  &__item {
    text-transform: uppercase;

    &:first-child {
      margin-top: 0;

      .menu__subtitle {
        margin-top: 0;
      }
    }
  }

  &__subtitle {
    cursor: default;

    @include mq(mobile) {
      line-height: 25px;
    }

    @include mq($until: ipadP) {
      font-size: 0.8rem
    }
  }

  &__title {
    cursor: pointer;

    @include fluid-type(
        map_get($mq-breakpoints, mobile),
        map_get($mq-breakpoints, dl),
        $font-size-menu-item-mobile,
        $font-size-menu-item-default,
        $lheight-menu-item-mobile,
        $lheight-menu-item-default
    );
  }
}

.menu__head,
.menu__foot {
  &__line {
    display: block;
    position: absolute;
    bottom: 1px;
    left: 0;
    width: 100%;
    height: 1px;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;

      background: $color-label;
    }

    &::before {
      transform: translate3d(0%, 0, 0);
      opacity: 1;
      transition: transform 0.4s cubic-bezier(.165, .84, .44, 1);
    }

    &::after {
      transform: translate3d(-102%, 0, 0);
      opacity: 0;
    }
  }
}
</style>
